import React, { useState } from "react";
import { Link } from "react-router-dom";
import { conciergeCmsFindPin } from "../../../../utils/conciergeCmsAuth";

export default function ConciergeUserFindPin() {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    try {
      setLoading(true);
      setError("");
      setPin("");
      const data = await conciergeCmsFindPin(name.trim(), phone.replace(/\D/g, ""));
      setPin(data.pin || "");
    } catch (err) {
      setError(err.message || "핀번호를 찾지 못했습니다.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#222] px-4 py-8">
      <div className="mx-auto flex min-h-[calc(100vh-64px)] max-w-[1700px] items-center justify-center rounded-[28px] bg-[#f7f7f8] shadow-[0_30px_80px_rgba(0,0,0,0.35)]">
        <div className="w-full max-w-[420px] rounded-2xl border border-[#e9e9ef] bg-white p-6 shadow-[0_12px_24px_rgba(15,23,42,0.08)]">
          <h1 className="text-[18px] font-bold text-[#111827]">핀번호 찾기</h1>

          <form className="mt-5 space-y-3" onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder="이름"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="h-11 w-full rounded-lg border border-[#e5e7eb] px-4 text-sm outline-none focus:border-[#7864F9]"
            />

            <div className="grid grid-cols-[1fr_88px] gap-3">
              <input
                type="tel"
                inputMode="numeric"
                pattern="[0-9]*"
                placeholder="휴대폰 번호"
                value={phone}
                onChange={(e) =>
                  setPhone(e.target.value.replace(/\D/g, "").slice(0, 11))
                }
                className="h-11 min-w-0 rounded-lg border border-[#e5e7eb] px-4 text-sm outline-none focus:border-[#7864F9]"
              />
              <button
                type="submit"
                disabled={loading}
                className="h-11 w-full rounded-lg bg-[#7864F9] px-3 text-sm font-semibold text-white disabled:opacity-60"
              >
                조회
              </button>
            </div>
          </form>

          {pin ? (
            <div className="mt-4 rounded-xl bg-[#f5f3ff] px-4 py-3 text-sm text-[#4c1d95]">
              현재 핀번호: <span className="font-bold">{pin}</span>
            </div>
          ) : null}

          {error ? <div className="mt-3 text-xs text-red-500">{error}</div> : null}

          <div className="mt-4 text-xs text-[#4b5563]">
            <Link to="/concierge/manage/login" className="text-[#7864F9]">
              로그인으로 돌아가기
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
